document.addEventListener('DOMContentLoaded', () => {
  const productSelector = document.querySelector('.product-selector');
  if (productSelector) {
    productSelector.addEventListener('click', (event) => {
      const button = event.target.closest('.product-selector__item');
      if (button) {
        const productUrl = button.dataset.productUrl;
        if (productUrl) {
          // Añadir clase para iniciar la animación de desvanecimiento
          document.body.classList.add('page-transition');
          
          // Retrasar la recarga de la página para permitir que la animación se complete
          setTimeout(() => {
            window.location.href = productUrl;
          }, 300); // 300ms de retraso, ajusta según sea necesario
        }
      }
    });
  }
});

// Asegurarse de que la animación de entrada se active después de que la página se cargue
window.addEventListener('pageshow', (event) => {
  if (event.persisted) {
    // Si la página se carga desde el caché del navegador (por ejemplo, al usar el botón "atrás")
    document.body.classList.remove('page-transition');
  } else {
    // Para cargas normales de página
    requestAnimationFrame(() => {
      document.body.classList.remove('page-transition');
    });
  }
});